export const PRICING_ITEM_V1_TAG = 'ofc-pricing-item-v1';
